import { BlockProps } from "@/utils/types";
import { ReactNode } from "react";
import { WaveBorder } from "../WaveBorder";
import { Heading } from "../modules/Heading";
import { sanitize } from "@/utils/sanitize";

interface BlockWrapperProps extends BlockProps {
  children: ReactNode;
  lightMode?: boolean;
}

export const BlockWrapper = ({
  backgroundColor = "bg-white",
  bottom,
  children,
  className,
  primaryEnder,
  colorStarter,
  lightMode,
  componentId,
  heading,
}: BlockWrapperProps) => {
  const headingClasses =
    sanitize(backgroundColor) === "waves" || lightMode
      ? "text-secondaryDark"
      : "text-white";

  const darkWave =
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary" ||
    sanitize(backgroundColor) === "pattern";

  return (
    <section
      id={componentId}
      className={`blockWrapper relative w-full py-16 md:pt-32 ${!primaryEnder ? (bottom ? "md:pb-48" : "md:pb-32") : "pb-0"}${
        backgroundColor
          ? ` ${sanitize(backgroundColor) === "pattern" ? "pattern bg-secondary" : sanitize(backgroundColor) === "waves" ? "waves bg-white" : sanitize(backgroundColor)}`
          : ""
      }${colorStarter ? " -mt-11" : ""}${className ? ` ${sanitize(className)}` : ""}`}
    >
      {sanitize(backgroundColor) === "pattern" && (
        <div
          className="absolute top-0 left-0 w-full h-full  bg-repeat bg-fixed opacity-30"
          style={{ backgroundImage: `url(/bgPattern.png)` }}
        />
      )}

      {heading && heading.copy && (
        <Heading
          {...heading}
          noWave={heading.numberOfWaves === 0}
          waveColor={darkWave ? "#540389" : undefined}
          className={`${headingClasses} z-[2]`}
        />
      )}
      <div className="inner relative z-[2]">{children}</div>
      {(sanitize(backgroundColor) === "waves" ||
        sanitize(backgroundColor) === "wavesFull") && (
        <>
          <WaveBorder
            className={`z-[1] pointer-events-none absolute top-0 left-0 bg-center${sanitize(backgroundColor) === "wavesFull" ? " h-auto" : " h-full"}`}
          />
          <div
            className={`bg-box pointer-events-none bg-primary ${sanitize(backgroundColor) === "wavesFull" ? "h-waveFull" : "h-1/2"} w-full absolute bottom-0 left-0`}
          />
        </>
      )}
    </section>
  );
};
